export class CryptoEnvironment {
  public static getName = () => 'benzinga-crypto';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://www.benzinga.com/lavapress/'),
  });
}
